import axios from "axios";
import { baseUrl } from "../Common/Constants";
import { Credentials } from "../Common/Types/types";
class _AuthApi {
    loginTest(): Promise<boolean> {
        const url = baseUrl + "auth";
        return axios
            .get(url, { withCredentials: true })
            .then(() => true)
            .catch(() => false);
    }

    async login(creds: Credentials): Promise<boolean> {
        const tokenUrl = baseUrl + "auth/token";
        const loginUrl = baseUrl + "auth";

        try {
            const tokenResponse = await axios.get<{ token: string }>(tokenUrl, {
                withCredentials: true,
            });

            const token = tokenResponse.data.token;

            await axios.post(loginUrl, creds, {
                headers: {
                    "X-CSRF-TOKEN": token,
                },
                withCredentials: true,
            });

            return true;
        } catch {
            return false;
        }
    }

    async logout(): Promise<boolean> {
        const tokenUrl = baseUrl + "auth/token";
        const logoutUrl = baseUrl + "auth";

        try {
            const tokenResponse = await axios.get<{ token: string }>(tokenUrl, {
                withCredentials: true,
            });
            const token = tokenResponse.data.token;

            await axios.delete(logoutUrl, {
                headers: {
                    "X-CSRF-TOKEN": token,
                },
                withCredentials: true,
            });

            return true;
        } catch {
            return false;
        }
    }

}

export const AuthApi = new _AuthApi();
